const camelCaseToSnakeCase = (key: string): string => key.replace(/([A-Z])/g, '_$1').toLowerCase();

export const camelCaseObjectToSnakeCase = <T>(obj: Record<string, unknown>): T => {
  if (typeof obj !== 'object') return obj;

  for (const oldName in obj) {
    const newName = camelCaseToSnakeCase(oldName);
    if (newName !== oldName) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }

    if (typeof obj[newName] === 'object') {
      obj[newName] = camelCaseObjectToSnakeCase(obj[newName] as Record<string, unknown>);
    }
  }
  return obj as T;
};
